const DOMAIN = 'https://www.creditas.com'

const safeReferrer = referrer => {
  const url = new URL(referrer, DOMAIN)

  return `${url.pathname}${url.search}`
}

export { safeReferrer }
